import { Link, useLocation } from '@remix-run/react'
import { motion } from 'framer-motion'
import { Hexagon, UserRound } from 'lucide-react'
import { useStoreContext } from '#app/store'
import { cn } from '#app/utils/misc'
import logoSvg from '../images/logo.svg'
import { Badge } from './ui/badge'
import { Button } from './ui/button'

export function Header() {
	const selectedPlotIds = useStoreContext(s => s.selectedPlotIds)
	// const { user } = useLoaderData()
	const location = useLocation()

	const isHome = location.pathname === '/'

	return (
		<header
			className="pointer-events-none fixed left-0 top-4 z-10 m-auto my-0 
			flex h-10 w-full flex-row items-center justify-between px-2 md:px-6"
		>
			<Button variant="link" asChild>
				<Link to="/" prefetch="intent">
					{/* if homepage wrap in h1 */}
					{isHome ? (
						<h1>
							<img src={logoSvg} alt="Erda" />
						</h1>
					) : (
						<img src={logoSvg} alt="Erda" />
					)}
				</Link>
			</Button>

			<div className="mt-0.5 flex gap-3">
				<motion.div
					variants={{
						visible: { scale: 1, rotate: 0, opacity: 1 },
						hidden: { scale: 0.5, rotate: 10, opacity: 0 },
					}}
					initial="hidden"
					animate={selectedPlotIds.length > 0 ? 'visible' : 'hidden'}
					transition={{
						type: 'spring',
						stiffness: 300,
						damping: 20,
					}}
				>
					<Button asChild variant="link">
						<Link to="/basket">
							<div>
								<Hexagon
									className={cn(
										'h-10 w-10 fill-black/10 transition-[stroke-dashoffset] duration-1000 hover:[stroke-dashoffset:5] dark:fill-white/10',
										// !isLoading && 'duration-1000 hover:[stroke-dashoffset:5]',
										// isLoading && 'animate-stroke-offset',
									)}
									strokeDasharray={3}
									strokeWidth={1.5}
								/>
								<Badge
									variant="destructive"
									className={cn(
										'pointer-events-none absolute bottom-0 right-0 h-5 w-5 items-center justify-center p-0 ',
										selectedPlotIds.length > 99 && 'w-7',
									)}
								>
									{selectedPlotIds.length}
								</Badge>
							</div>
						</Link>
					</Button>
				</motion.div>

				<Button
					variant="link"
					asChild
					className="mt-0.5 !h-10 w-10 rounded-full border bg-background"
				>
					<Link to="/account">
						{/* TODO (low) swap for user image */}
						{/* {user ? (
							<Avatar className="h-10 w-10 rounded">
								<AvatarImage
									src={user.imageUrl ?? ''}
									className="flex h-full w-full items-center justify-center rounded-full bg-background object-cover"
								/>
								<AvatarFallback className="text-xl uppercase">
									{user.handle.slice(0, 1)}
								</AvatarFallback>
							</Avatar>
						) : ( */}
						<UserRound className="h-6 w-6" />
						{/* )} */}
					</Link>
				</Button>
			</div>
		</header>
	)
}
